export default __webpack_public_path__ + "static/media/globe.3bcbf791.svg";